var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('nav-bar'),_c('router-view',{staticClass:"router",staticStyle:{"padding-bottom":"1rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }